import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=warm%20minimalist%20abstract%20geometric%20composition%20with%20soft%20cream%20beige%20and%20terracotta%20gradients%20flowing%20organic%20shapes%20with%20subtle%20texture%20elegant%20editorial%20design%20background%20with%20gentle%20light%20accents&width=1800&height=1000&seq=hero-bg-main&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6"
          style={{ fontFamily: "var(--font-heading)" }}>
          让你的Po文<br className="md:hidden" />获得最高曝光
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          从po文标题撰写、内容排版到最佳发布时机，<br className="hidden md:block" />
          我们提供最全面的po文技巧与策略，帮助每一位创作者让优质内容被更多人看见。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/tips"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg font-semibold text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
          >
            开始学习Po文技巧
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/category/examples"
            className="w-full sm:w-auto px-8 py-3.5 bg-white/15 backdrop-blur-sm text-white rounded-lg font-semibold text-sm hover:bg-white/25 transition-all duration-300 whitespace-nowrap border border-white/20"
          >
            查看Po文范例
          </Link>
        </div>

        <div className="mt-14 flex items-center justify-center gap-8 text-white/60 text-sm">
          <div className="text-center">
            <p className="text-2xl font-bold text-white">200+</p>
            <p className="mt-1">精选文章</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl font-bold text-white">6</p>
            <p className="mt-1">内容分类</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl font-bold text-white">50K+</p>
            <p className="mt-1">月访问量</p>
          </div>
        </div>
      </div>
    </section>
  );
}